import React from "react";
import { useParams, NavLink, Navigate } from "react-router-dom";
import { POLICIES, POLICY_NAV, BRAND } from "@/data/policies";

export default function PolicyPage() {
  const { slug } = useParams();
  const policy = POLICIES[slug];

  if (!policy) return <Navigate to="/policies/shipping" replace />;

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12" data-testid={`policy-page-${slug}`}>
      <div className="mb-10">
        <div className="font-mono text-xs text-[#FF3B30] tracking-widest">SUPPORT / POLICIES</div>
        <h1 className="font-display text-5xl md:text-7xl tracking-tighter mt-2 text-black">{policy.title}</h1>
        <p className="text-black/60 mt-4 max-w-2xl">{policy.intro}</p>
      </div>

      <div className="grid lg:grid-cols-[260px_1fr] gap-10">
        <aside className="lg:sticky lg:top-32 lg:self-start space-y-1">
          <div className="font-mono text-[10px] tracking-widest text-black/40 mb-3">JUMP TO</div>
          {POLICY_NAV.map((item) => (
            <NavLink
              key={item.slug}
              to={`/policies/${item.slug}`}
              data-testid={`policy-nav-${item.slug}`}
              className={({ isActive }) =>
                `block px-3 py-2 font-display tracking-widest text-xs border-l-2 ${
                  isActive ? "border-[#FF3B30] bg-black/5 text-black" : "border-transparent text-black/60 hover:text-black"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <div className="mt-8 border-t border-black/10 pt-6">
            <div className="font-mono text-[10px] tracking-widest text-black/40 mb-2">NEED MORE HELP?</div>
            <a href="/contact" className="font-display tracking-widest text-xs underline">CONTACT US →</a>
          </div>
        </aside>

        <div className="space-y-10">
          {policy.sections.map((section) => (
            <section key={section.heading}>
              <h2 className="font-display text-2xl md:text-3xl tracking-tighter text-black border-b border-black/10 pb-2">{section.heading}</h2>
              <ul className="mt-4 space-y-2">
                {section.bullets.map((b) => (
                  <li key={b} className="text-black/80 leading-relaxed flex gap-3">
                    <span className="text-[#FF3B30] mt-1.5 shrink-0">◆</span>
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
          <div className="mt-12 p-6 border border-black/15 bg-black/[0.02]">
            <div className="font-display tracking-widest text-xs text-black/50">LAST UPDATED</div>
            <div className="font-mono text-sm text-black mt-1">February 2026</div>
            <div className="text-sm text-black/70 mt-3">
              Questions? Email <a href={`mailto:${BRAND.email}`} className="text-[#FF3B30] underline">{BRAND.email}</a> or message us on WhatsApp.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
